import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import _ from 'lodash'

import { moreFilterOptions } from '../configuration/filtering'
import { useFilterTours } from './useFilterTours'
import { getFilters } from '../redux/reducers/filters'
import { getTours } from '../redux/reducers/tours'

export function useGetMoreFilterOptionsForMoreFiltersType(filterKey) {
  const filters = useSelector(getFilters)
  const tours = useSelector(getTours)

  const otherFilters = _.omit(filters, moreFilterOptions)

  const filteredTours = useFilterTours(tours, otherFilters)

  return useMemo(() => {
   return  _.sortBy(_.union(..._.map(filteredTours, tour => tour[filterKey])))
  }, [filterKey, filteredTours])
}
